/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_log_in5 = /** @type {(inputs: {}) => string} */ () => {
	return `Log in`
};

const fr_log_in5 = /** @type {(inputs: {}) => string} */ () => {
	return `Se connecter`
};

const de_log_in5 = /** @type {(inputs: {}) => string} */ () => {
	return `Einloggen`
};

const es_log_in5 = /** @type {(inputs: {}) => string} */ () => {
	return `Iniciar sesión`
};

const it_log_in5 = /** @type {(inputs: {}) => string} */ () => {
	return `Login`
};

const ar_log_in5 = /** @type {(inputs: {}) => string} */ () => {
	return `تسجيل الدخول`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const log_in5 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.log_in5(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("log_in5", locale)
	if (locale === "en") return en_log_in5(inputs)
	if (locale === "fr") return fr_log_in5(inputs)
	if (locale === "de") return de_log_in5(inputs)
	if (locale === "es") return es_log_in5(inputs)
	if (locale === "it") return it_log_in5(inputs)
	return ar_log_in5(inputs)
};
export { log_in5 as "LOG_IN" }